import WatchHealthReports from '@/components/watch/healthreports/HealthReports'
import WatchHealthReportsView from '@/components/watch/healthreports/HealthReportsView'

export default [
	{
		path: 'healthreports',
		name: 'WatchHealthReports',
		component: WatchHealthReports,
		props: (route) => ({
			user_uid: route.params.user_uid,
			watch_id: route.params.watch_id,
			profile: route.params.profile
		}),
		children: [
			{
				path: ':report_id',
				name: 'WatchHealthReportsView',
				component: WatchHealthReportsView,
				props: (route) => ({
					user_uid: route.params.user_uid,
					watch_id: route.params.watch_id,
					report_id: route.params.report_id
				})
			}
		]
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/watch/healthreports.js